export default __webpack_public_path__ + "static/media/event 1.f4c9ad1e.JPG";